import React from 'react';
import { Grid, Typography } from '@mui/material';
import IconCalendar from '../svg/icon-calendar.svg';
import IconClock from '../svg/icon-clock.svg';
import { formatDuration, formatTimeDuration } from '../../utils/format';
import { isSessionEndTimeHidden } from '../../utils/transform';

interface IProps {
  event: any;
}

const EventCollapsedInfo: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const { event } = props;
  const { start_at, end_at, timezone, sessions } = event;
  const hideEndTime = isSessionEndTimeHidden(sessions, end_at);
  const time = start_at && end_at && formatTimeDuration(start_at, hideEndTime ? null : end_at, timezone);
  const duration = start_at && end_at && formatDuration(start_at, end_at, timezone);

  return (
    <Grid container spacing={3}>
      <Grid item>
        <Grid container alignItems="center" spacing={1}>
          <Grid style={{ paddingTop: 12 }} item>
            <IconCalendar />
          </Grid>
          <Grid item>
            <Typography variant="body1" color="primary" style={{ fontWeight: 600 }}>
              {duration}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {time && (
        <Grid item>
          <Grid container alignItems="center" spacing={1}>
            <Grid style={{ paddingTop: 12 }} item>
              <IconClock />
            </Grid>
            <Grid item>
              <Typography variant="body1" color="primary" style={{ fontWeight: 600 }}>
                {time}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default EventCollapsedInfo;
